import styled from "styled-components";

const StyledAnalytics = styled.div`
	background-color: ${({ theme }) => theme.colors.porcelain};
	padding: 40px;
	min-height: calc(100vh - 56px);
	@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
		padding: 16px;
	}

	.sb-analytics {
		&__cards-container {
			padding: 24px 0;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 6px 0;
			}
		}
		&__filters {
			.ant-space-compact {
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					width: 100%;
				}
			}

			&__range_picker {
				position: relative;

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					width: 100%;
				}

				.ant-picker {
					border-color: rgb(227, 229, 231);
					width: 100%;
					height: 40px !important;
					box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);

					.ant-picker-input {
						input {
							color: rgb(79, 86, 97);
							font-weight: 700;
							font-size: 16px !important;
							line-height: 24px;
							font-family: "DM Sans";
							letter-spacing: 1px;
						}
					}
					.ant-picker-suffix {
						color: rgb(79, 86, 97);
						font-size: 12px;
						line-height: 0px;
					}
				}
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					.custom-picker-range-popup-responsive {
						position: absolute !important;
						top: 100% !important;
						left: 0 !important;
						right: 0 !important;
						transform: none !important;
						margin-top: 8px !important;
						width: 100vw !important;
						max-width: 100% !important;
						min-width: 100% !important;
						z-index: 9999 !important;

						.ant-picker-range-wrapper {
							[class^="ant-picker"],
							[class*=" ant-picker"] {
								font-size: 12px;
							}
						}
					}
				}
			}
		}
	}
`;

export default StyledAnalytics;

